import { render } from "./Wenluotang2025.vue?vue&type=template&id=570d37e8&scoped=true"
import script from "./Wenluotang2025.vue?vue&type=script&lang=js"
export * from "./Wenluotang2025.vue?vue&type=script&lang=js"

import "./Wenluotang2025.vue?vue&type=style&index=0&id=570d37e8&scoped=true&lang=css"

import exportComponent from "C:\\ZYSRC\\FW\\fwm_web-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570d37e8"]])

export default __exports__